// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content. 

export const SIDEBAR_WIDTH = 250;
export const DEFAULT_CHARACTER_LIMIT = 5000;
export const REJECTED_NOTE_CHARACTER_LIMIT = 250;
export const APPLICATION_STATEMENT_CHARACTER_LIMIT = 5000;
